module.exports = __webpack_public_path__ + "static/media/dash.ed282b54.jpg";